import React, { useEffect, useMemo, useState } from 'react';
import './startSection.scss';
import { ReactComponent as StartPlanetBottom } from "./icons/StartPlanetBottom.svg";
import { ReactComponent as StartBgComponents } from "./icons/StartBgComponents.svg";
import { ReactComponent as StartLightComponents } from "./icons/StartLightComponents.svg";
import { ReactComponent as StartLightLeftComponents } from "./icons/StartLightLeftComponents.svg";
import { ReactComponent as StartBg2Components } from "./icons/StartBg2Components.svg";
import { ReactComponent as StartStarsComponents } from "./icons/StartStarsComponents.svg";
import { ReactComponent as StartRayComponents } from "./icons/StartRayComponents.svg";
import { ReactComponent as StartTopShineComponents } from "./icons/StartTopShineComponents.svg";
import { throttle } from 'lodash';

const StartSection = () => {
	const [width, setWidth] = useState(() => {
		if (typeof window !== 'undefined') {
			return window.innerWidth;
		}
		return 0;
	});
	
	useEffect(() => {
		const handleResize = () => {
			setWidth(window.innerWidth);
		};
		
		const throttledResize = throttle(handleResize, 200);
		window.addEventListener('resize', throttledResize);
		
		return () => {
			window.removeEventListener('resize', throttledResize);
		};
	}, []);
	
	const desktopLayers = useMemo(() => (
		<>
			<div className="startSection__layer _1">
				<StartBgComponents className="startSection__layer_item main" style={{ mixBlendMode: 'overlay'}}/>
			</div>
			<div className="startSection__layer _2">
				<StartLightComponents className="startSection__layer_item light" style={{mixBlendMode: 'plus-lighter'}}/>
				<StartLightLeftComponents className="startSection__layer_item lightLeft" style={{mixBlendMode: 'plus-lighter'}}/>
			</div>
			<div className="startSection__layer _3">
				<StartBg2Components className="startSection__layer_item startBg" style={{mixBlendMode: 'color-dodge'}}/>
			</div>
			<div className="startSection__layer _4">
				<StartStarsComponents className="startSection__layer_item mainStars" style={{mixBlendMode: 'soft-light'}}/>
			</div>
			<div className="startSection__layer _5">
				<StartTopShineComponents className="startSection__layer_item topShine" style={{mixBlendMode: 'overlay'}}/>
				<StartRayComponents className="startSection__layer_item ray" style={{mixBlendMode: 'plus-lighter'}}/>
			</div>
		</>
	), []);
	
	const mobileBg = useMemo(() => (
		<div className="startSection__mobile-bg">
			<img
				src={`${process.env.PUBLIC_URL}/assets/images/start/StartBgAdaptive.webp`}
				alt="Start bg"
				loading="lazy"
				className="startSection__mobile-img"
			/>
		</div>
	), []);
	
	return (
		<div className="startSection">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			{
				width > 767 ? desktopLayers : mobileBg
			}
			
			<div className="startSection__content">
				<h1>Ultimate Web3 ecosystem</h1>
				<span>Simplify and enhance your crypto experience with innovative products from the NFD team.</span>
				<button
					className="secondButton"
					onClick={() => {}} // navigate('/blog')
				>
					<span>Get Started</span>
				</button>
			</div>
			
			<div className="startSection__planet">
				{
					width > 767 ? (
						<StartPlanetBottom />
						) : (
							<img
								src={`${process.env.PUBLIC_URL}/assets/images/start/StartPlanetAdaptive.webp`}
								alt="Start planet"
								loading="lazy"
							/>
						)
				}
				{
					width > 767 ? (
						<div className="startSection__planet_bg_1"></div>
					) : null
				}
			</div>
		</div>
	);
};

export default StartSection;